import { Box, Grid, Typography } from '@mui/material';
import { useStyles } from '../style';
import _ from 'lodash';
import { PageContainer } from 'components';
import { useEffect, useState } from 'react';
import InitFilteringReportSummary from '../constants/InitFilteringReportSummary';
import { toFilterVOS } from 'components/FilterPod';
import { FilterPod, ExportButton , PriceLabel} from 'components';
import { useExportFile } from 'hooks';
import ImprestServices from '../../services/ImprestServices';
import { NewLoading } from 'components';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction } from 'utility';
import {
  getExportFunderImprestUrl,
} from 'URLs';
export default function ImprestFunderReportSummary({currencyText}) {
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState(InitFilteringReportSummary());
  const [filterParams, setFilterParams] = useState(null);
  const classes = useStyles();
  const [data, setData] = useState(null);
  const { downloadFile, isExporting } = useExportFile({
    url: getExportFunderImprestUrl(),
    filename: 'funderImprest-report',
  });

  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);
  const actionsList =
    getDynamicObjectAction([
      'imprestFunderPage',
      'exportAggregationAllImprestFunderPage'

    ])
  const filterVOStoQueryStrWithId = (filters) => {
    const queries = {};
    filters.forEach((v) => {
      if (v?.value != null) {
        const k = v?.id ?? null;
        if (k) {
          queries[k] = v?.value;
        }
      }
    });
    return queries;
  };
  const getData = () => {
    setLoading(true);
    setData(null);
    const newFilters = [...filters];
    const filter = toFilterVOS([...newFilters]);
    let queries = filterVOStoQueryStrWithId(filter);

    let params = {
      ...queries,
    };
    const data = {
      filterVOS: [],
      parentParams: [],
      orderByElementVOS: [],
    };
    setFilterParams({ data, params });
    ImprestServices.funderImprest(data, params)
      .then((res) => {
        setData(generateData(res?.result?.rows[0]));
        setLoading(false);
      })
      .catch((error) => {

        setLoading(false);
      });
  };
  useEffect(() => { }, []);

  const onChangeTemp = (tmp) => {
    setFilters(tmp);
  }
  const onExport = (type, index) => {
    const types = ['xls', 'csv'];
    downloadFile(types[index], filterParams?.data, filterParams?.params);
  };


  const generateData = (row, query) => {
    const newData = {
      countImprestFunder: row.cols[0], // تعداد کل تنخواه
      sumDiscount: row.cols[1], // مجموع واریز تنخواه
      sumWidraw: row.cols[2], // مجموع برداشت تنوخاه
      balanceRial: row.cols[3], // مانده 
      balanceNotUse: row.cols[4], // مانده اعتبار مصرف نشده
      sumUsable: row.cols[5], // مجموع قابل مصرف
      totalAmount: row.cols[6], // مبلغ کل اعتبار تخصیص شده
    };
    return newData;
  };

  const hint = 'محدوده تاریخ حداکثر 3 ماه گذشته می باشد.';

  return (
    <PageContainer
      title="گزارش تجمیعی"
      className={classes.root}
      description={hint}
    >
      <Grid item xs={12}>
        <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
          {actionsList['imprestFunderPage'] && (
            <FilterButton
              setOpenFilterDialog={setOpenFilterDialog}
              filters={filters}
            />
          )}
          {actionsList['exportAggregationAllImprestFunderPage'] && (
            <ExportButton
              loading={isExporting}
              types={['xls', 'csv']}
              onExport={onExport}
            />
          )}
        </Box>
        {actionsList['imprestFunderPage'] && (
          <Box>
            <FilterPod
              filters={filters}
              onChange={getData}
              onChangeTemp={onChangeTemp}
              openFilterDialog={openFilterDialog}
              setOpenFilterDialog={setOpenFilterDialog}
              handleCloseFilterDialog={handleCloseFilterDialog}
            />
          </Box>
        )}
      </Grid>
      {actionsList['imprestFunderPage'] && (
        <Grid container direction="row" alignItems="center" item>
          <Grid item xs={12}>

            {loading ? (
              <Grid container xs={12} md={12} style={{ position: 'relative', minHeight: '200px' }}>
                <NewLoading />
              </Grid>
            ) : (
              <Grid container xs={12} md={12} className={classes.info}>
                <Grid item xs={12} md={6} lg={3} className={classes.detail}>
                  <Typography className={classes.detailTitle}>تعداد کل تراکنش تنخواه</Typography>
                  <Typography className={classes.detailValue}>
                     <PriceLabel amount={data?.countImprestFunder} />
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={3} className={classes.detail}>
                  <Typography className={classes.detailTitle}>مجموع واریز تنخواه</Typography>
                  <Typography className={classes.detailValue}>
                    <PriceLabel amount={data?.sumDiscount} />
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={3} className={classes.detail}>
                  <Typography className={classes.detailTitle}>مجموع برداشت تنخواه</Typography>
                  <Typography className={classes.detailValue}>
                     <PriceLabel amount={data?.sumWidraw} />
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={3} className={classes.detail}>
                  <Typography className={classes.detailTitle}>مجموع مانده {currencyText}ی تنخواه </Typography>
                  <Typography className={classes.detailValue}>
                      <PriceLabel amount={data?.balanceRial} />
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={3} className={classes.detail}>
                  <Typography className={classes.detailTitle}>
                    {' '}
                    مجموع اعتبار مصرف نشده تنخواه{' '}
                  </Typography>
                  <Typography className={classes.detailValue}>
                      <PriceLabel amount={data?.balanceNotUse} />
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={3} className={classes.detail}>
                  <Typography className={classes.detailTitle}>مجموع تنخواه قابل مصرف</Typography>
                  <Typography className={classes.detailValue}>
                     <PriceLabel amount={data?.sumUsable} />
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6} lg={3} className={classes.detail}>
                  <Typography className={classes.detailTitle}>مبلغ کل اعتبار تخصیص شده </Typography>
                  <Typography className={classes.detailValue}>
                     <PriceLabel amount={data?.totalAmount} />
                  </Typography>
                </Grid>
              </Grid>
            )}

          </Grid>
        </Grid>
      )}
    </PageContainer>
  );
}
